<template>
  <div class="design">
    <div class="full-section anim anim-opacity-1" data-section="start" data-anim>
      <div class="full-section__container">
        <div class="full-section__background">
          <div v-rellax="rellax" class="rellax">
            <img src="@/assets/img/design/design_1.jpg" alt="">
            <img src="@/assets/img/design/design_1_mob.jpg" alt="" class="rellax-mob">
          </div>
        </div>
        <div class="full-section__foreground">
          <div class="full-section__animate">
            <div class="full-section__subtitle anim anim-start-1">
              <span class="full-section__subtitle-text">ДИЗАЙН</span>
              <span class="full-section__subtitle-line"></span>
            </div>
            <div class="full-section__title anim anim-start-2">
              Элегантность и продуманная<br> функциональность
            </div>
            <div class="full-section__desc anim anim-start-3">
              Совершенная инвестиция
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="design-container" data-container="1">
      <div class="design-left" data-anim>
        <img src="@/assets/img/design/design_2.jpg" alt="" class="anim anim-scene-1 hide-mob" />
        <img src="@/assets/img/design/design_2_mob.jpg" alt="" class="anim anim-scene-1 show-mob" />
      </div>
      <div class="design-right design-first">
        <p class="design-text anim anim-scene-2 anim-scene-1-mob" data-anim>
          С первого взгляда до&nbsp;обоснования в&nbsp;доме, кухни LITHIUM
          не&nbsp;перестают удивлять и&nbsp;вызывать восторг своих клиентов.
          Сталь, керамика, стекло, селективная древесина обретают самые
          изысканные сочетания в&nbsp;изделиях LITHIUM. Особый подход
          к&nbsp;дизайну, внимание к&nbsp;мельчайшим деталям, эксклюзивность
          используемых материалов и&nbsp;следование ведущим мировым трендам
          позволяют бренду конкурировать с&nbsp;лучшими европейскими
          производителями, выигрышно отличаясь ценой.
        </p>
        <p class="design-text anim anim-scene-3 anim-scene-1-mob" data-anim>
          Тринадцать дизайн-концептов мебели, которые можно персонализировать
          в&nbsp;соответствии с&nbsp;вашими функциональными потребностями
          и&nbsp;стилем жизни. Учесть все конструктивные особенности
          пространства и&nbsp;сформировать единый гармоничный дизайн всего
          интерьера.
        </p>
      </div>
    </div>

    <div class="design-container" data-container="1a" data-anim>
      <p class="design-section-title anim anim-scene-1">
        Единство визуальной эстетики и технологий
      </p>
      <p class="design-text anim anim-scene-2 hide-mob">
        Особое внимание в LITHIUM уделяется техническому оснащению кухонь. Инновации в сочетании современных технологий и
        передовых инженерных решений, позволяют добиваться выдающегося удобства эксплуатации.
      </p>
    </div>

    <div class="design-container" data-container="2">
      <Swiper class="design-slider" :options="sliderOption" ref="slider" data-anim>
        <Swiper-slide class="design-slide anim anim-scene-2">
          <img src="@/assets/img/design/design_3.jpg" alt="" class="hide-mob" />
          <img src="@/assets/img/design/design_3_mob.jpg" alt="" class="show-mob anim anim-opacity-1" />
        </Swiper-slide>
        <Swiper-slide class="design-slide anim anim-scene-3">
          <img src="@/assets/img/design/design_4.jpg" alt="" class="hide-mob" />
          <img src="@/assets/img/design/design_4_mob.jpg" alt="" class="show-mob anim anim-opacity-1" />
        </Swiper-slide>
        <Swiper-slide class="design-slide anim anim-scene-1">
          <img src="@/assets/img/design/design_5.jpg" alt="" class="hide-mob" />
          <img src="@/assets/img/design/design_5_mob.jpg" alt="" class="show-mob anim anim-opacity-1" />
        </Swiper-slide>

        <div class="swiper-button-prev anim anim-opacity-1" slot="button-prev" data-anim>
          <div class="design-slider__button">
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.37524 12.75L1.37524 6.75L7.37524 0.75" stroke="#2E2E2E" stroke-linecap="square" />
            </svg>
          </div>
        </div>

        <div class="swiper-button-next anim anim-opacity-2" slot="button-next" data-anim>
          <div class="design-slider__button">
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.62476 1.25L7.62476 7.25L1.62476 13.25" stroke="#2E2E2E" stroke-linecap="square" />
            </svg>
          </div>
        </div>

        <div class="slider-pagination anim anim-opacity-4" slot="pagination"></div>
      </Swiper>

      <p class="design-text design-text--mob anim anim-scene-1 show-mob" data-anim>
        Особое внимание в&nbsp;LITHIUM уделяется техническому оснащению кухонь. Инновации в&nbsp;сочетании современных
        технологий и&nbsp; передовых инженерных решений, позволяют добиваться выдающегося удобства эксплуатации.
      </p>
    </div>

    <div class="design-container" data-container="3">
      <div class="design-left" data-anim>
        <div class="sticky">
          <h2 class="design-section-title anim anim-scene-1">
            Опережая тренды
          </h2>
          <p class="design-text anim anim-scene-2">
            Напольные и&nbsp;подвесные секции, шкафы-колонны,
            мультифункциональные острова, индивидуально спроектированные для
            каждого концепта стеклянные витрины и&nbsp;бары, деревянные стеллажи
            и&nbsp;скрытые секции с&nbsp;техникой. Продуманные до&nbsp;мелочей
            модули для комфорта и&nbsp;восхищения.
          </p>
        </div>
      </div>
      <div class="design-right" data-anim>
        <div>
          <div class="product__item" :key="index" v-for="(product, index) in trends" :ref="'product-' + index">
            <h3 class="product__item-title anim" :class="[
              'anim-scene-' + (index + 2),
              'anim-scene-' + (index + 3) + '-mob',
            ]">
              <span class="product__item-counter">
                <span class="product__item-counter--active">{{ "0" + (index + 1) }}</span> / <span
                  v-text="trends.length < 10 ? '0' + trends.length : trends.length" />
              </span>
              {{ product.title }}
            </h3>
            <p class="product__item-desc anim" :class="'anim-scene-' + (index + 3)">
              {{ product.desc }}
            </p>
            <img :src="product.image" alt="" class="anim" :class="[
              'anim-scene-' + (index + 4),
              'anim-scene-' + (index + 2) + '-mob',
            ]" />
          </div>
        </div>

        <Swiper :options="swiperMob" ref="swiperMob" class="show-mob">
          <Swiper-slide v-for="(product, index) in trends" :key="index">
            <img :src="product.image" alt="" class="slide__img anim anim-scene-1" />
            <h3 class="product__item-title anim" :class="[
              'anim-scene-' + (index + 2),
              'anim-scene-' + (index + 3) + '-mob',
            ]">
              <span class="anim product__item-counter" :class="'anim-scene-' + (index + 2)">
                <span class="product__item-counter--active">{{ "0" + (index + 1) }}</span>
                / <span v-text="trends.length < 10 ? '0' + trends.length : trends.length" />
              </span>
              {{ product.title }}
            </h3>
            <p class="product__item-desc anim" :class="'anim-scene-' + (index + 3)">
              {{ product.desc }}
            </p>
          </Swiper-slide>
        </Swiper>
      </div>
    </div>

    <div class="design-container" data-container="7">
      <div class="design-right" data-anim>
        <h3 class="design-section-title anim anim-scene-1">
          Продуманная функциональность
        </h3>
        <p class="design-text anim anim-scene-2">
          Функциональные решения для ценителей порядка и&nbsp;эстетики.
          Эффективные системы хранения LITHIUM организуют идеальный порядок
          на&nbsp;вашей кухне. Для каждой мелочи предусмотрено свое место
          и&nbsp;удобный доступ к&nbsp;нему. Плавные механизмы модулей
          и&nbsp;высочайший комфорт движения дарят истинное наслаждение
          взаимодействия.
        </p>
      </div>

      <div class="slider" data-anim>
        <div class="slider-inner">
          <Swiper :options="cardSwiperDesign" ref="cardSwiperDesign">
            <Swiper-slide>
              <img src="@/assets/img/design/design_12.jpg" alt="" class="slide__img anim anim-scene-1" />
              <span class="slide__pagi anim anim-scene-2 show-mob">01</span>
            </Swiper-slide>
            <Swiper-slide>
              <img src="@/assets/img/design/design_11.jpg" alt="" class="slide__img anim anim-scene-2" />
              <span class="slide__pagi anim anim-scene-2 show-mob">02</span>
            </Swiper-slide>
          </Swiper>
          <div class="slider-controls">
            <div class="slider-pagination anim anim-opacity-4" slot="pagination"></div>
          </div>
          <!-- <div class="swiper-button-next" slot="button-next"></div> -->

          <div class="swiper-button-prev" slot="button-prev">
            <div class="design-slider__button">
              <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.37524 12.75L1.37524 6.75L7.37524 0.75" stroke="#2E2E2E" stroke-linecap="square" />
              </svg>
            </div>
          </div>

          <div class="swiper-button-next" slot="button-next">
            <div class="design-slider__button">
              <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.62476 1.25L7.62476 7.25L1.62476 13.25" stroke="#2E2E2E" stroke-linecap="square" />
              </svg>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="design-container design-container--text" data-container="20">
      <div class="design-right">
        <p class="design-text anim anim-scene-1" data-anim>
          Внутреннее убранство шкафов&nbsp;– предмет особой гордости LITHIUM.
          Разработкой его дизайна и&nbsp;эргономики занимается отдельное
          подразделение. Уникальный подбор материалов-компаньонов&nbsp;– стекло,
          сталь, натуральный шпон, кожа; деликтная интегрированная подсветка
          внутри шкафов и&nbsp;полок; вкладыши для приборов, выполненные вручную
          из ценных пород древесины; ножевые секции и&nbsp;банки для специй,
          изготовленные по&nbsp;специальному заказу.
        </p>
      </div>
    </div>

    <div class="design-container" data-container="2">
      <Swiper class="design-slider" :options="sliderOption" ref="slider" data-anim>
        <Swiper-slide class="design-slide">
          <img src="@/assets/img/design/design_13.jpg" alt="" class="anim anim-opacity-2" />
        </Swiper-slide>
        <Swiper-slide class="design-slide">
          <img src="@/assets/img/design/design_14.jpg" alt="" class="anim anim-opacity-3" />
        </Swiper-slide>
        <Swiper-slide class="design-slide">
          <img src="@/assets/img/design/design_15.jpg" alt="" class="anim anim-opacity-1" />
        </Swiper-slide>

        <div class="swiper-button-prev anim anim-opacity-1" slot="button-prev" data-anim>
          <div class="design-slider__button">
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.37524 12.75L1.37524 6.75L7.37524 0.75" stroke="#2E2E2E" stroke-linecap="square" />
            </svg>
          </div>
        </div>

        <div class="swiper-button-next anim anim-opacity-2" slot="button-next" data-anim>
          <div class="design-slider__button">
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.62476 1.25L7.62476 7.25L1.62476 13.25" stroke="#2E2E2E" stroke-linecap="square" />
            </svg>
          </div>
        </div>

        <div class="slider-pagination anim anim-opacity-4" slot="pagination" />
      </Swiper>
    </div>

    <div class="design-container design-container--text" data-container="20a">
      <div class="design-right">
        <p class="design-text anim anim-scene-1" data-anim>
          Безукоризненные кухни премиум-класса, соответствующие высочайшим мировым стандартам по привлекательной для
          российского
          потребителя цене.
        </p>
      </div>
    </div>
    <Form />
    <NextSection title="Реализованные проекты" link="/projects/" image="projects_next.jpg"
      imageMob="projects_next_mob.jpg" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import NextSection from '@/components/common/NextSection'
import Form from '@/components/common/Form'
import anims from '@/mixins/anims'
import rellax from '../../mixins/rellax'

export default {
  name: 'Design',

  components: {
    Swiper,
    Form,
    SwiperSlide,
    NextSection
  },

  mixins: [anims, rellax],

  data () {
    return {
      withMobileRellax: true,

      trends: [
        {
          title: 'Низкий цоколь',
          desc: 'Большая вместимость',
          image: require('@/assets/img/design/design_6.jpg')
        },
        {
          title: 'Стеклянные витрины и бары',
          desc: 'Эстетика',
          image: require('@/assets/img/design/design_7.jpg')
        },
        {
          title: 'Карманные двери',
          desc: 'Оптимизация пространства и элегантность',
          image: require('@/assets/img/design/design_8.jpg')
        },
        {
          title: 'Скрытая кухня',
          desc: 'Минимализм',
          image: require('@/assets/img/design/design_9.jpg')
        },
        {
          title: 'Керамические поверхности',
          desc: 'Натуральность',
          image: require('@/assets/img/design/design_10.jpg')
        }
      ],
      cardSwiperDesign: {
        navigation: {
          nextEl: '[data-container="7"] .swiper-button-next',
          prevEl: '[data-container="7"] .swiper-button-prev'
        },
        slidesPerView: 1,
        spaceBetween: 28,
        speed: 750,
        resistanceRatio: 0.5,
        simulateTouch: false,
        watchSlidesProgress: true,
        loop: true,

        pagination: {
          el: '[data-container="7"] .slider-pagination',
          type: 'fraction',
          formatFractionCurrent: function (number) {
            return ('0' + number).slice(-2)
          },
          formatFractionTotal: function (number) {
            return ('0' + number).slice(-2)
          }
        },
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 0
          },
          641: {
            slidesPerView: 1,
            freeMode: false,
            spaceBetween: 28
          }
        }
      },
      sliderOption: {
        speed: 750,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.slider-pagination',
          type: 'fraction',
          formatFractionCurrent: function (number) {
            return ('0' + number).slice(-2)
          },
          formatFractionTotal: function (number) {
            return ('0' + number).slice(-2)
          }
        },
        breakpoints: {
          1800: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 150
          },
          1536: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 140
          },
          1440: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 130
          },
          1366: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 120
          },
          1280: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 100
          },
          681: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 70
          },
          0: {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 28
          }
        }
      },
      swiperMob: {
        slidesPerView: 'auto',
        spaceBetween: 28,
        freeMode: true,
        breakpoints: {
          475: {
            spaceBetween: 16
          },
          320: {
            spaceBetween: 0
          }
        },
        speed: 750,
        resistanceRatio: 0.5,
        simulateTouch: false,
        watchSlidesProgress: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.full-section__container {
  height: calc(100vh - #{$header-height});
  color: #fff;
}

.design {
  font-family: "Helvetica";
  color: #666;
  background-color: #f2f2f2;

  .full-section {
    &__foreground {
      padding: vw(92) vw(125) vw(125);
      margin-top: 0;
    }

    &__subtitle {
      @include section-subtitle;
      display: flex;
      align-items: center;

      &-text {
        white-space: nowrap;
        margin-right: vw(30);
      }

      &-line {
        position: relative;
        width: 0;
        opacity: 0;
        height: 2px;
        background-color: #fff;
      }
    }

    &__title {
      @include section-title;
      max-width: vw(700);
      margin-top: auto;
      margin-bottom: vw(35) !important;
      font-size: vw(32);
      line-height: vw(42);
    }

    &__desc {
      font-size: vw(22.01);
      line-height: vw(26);
    }

    &__animate {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }
  }

  &-text {
    font-family: 'Helvetica';
    font-size: vw(18);
    line-height: vw(31.01);
    color: #666;

    &+& {
      margin-top: vw(55);

      @include max-width(mobile) {
        margin-top: vwm(46);
      }
    }

    &--margin {
      margin-bottom: vw(100);
    }

    @include max-width(mobile) {
      font-size: vwm(15);
      line-height: vwm(26);
    }

    &--remove-mob {
      @include max-width(mobile) {
        display: none;
      }
    }

    &--show-mob {
      display: none;

      @include max-width(mobile) {
        display: block;
      }
    }

    &--mob {
      @include max-width(mobile) {
        padding-top: vwm(46);
      }
    }
  }

  &-section-title {
    font-size: vw(32);
    line-height: vw(42);
    margin-bottom: vw(36);
    letter-spacing: 0.02em;
    color: #2e2e2e;

    @include max-width(mobile) {
      font-size: vwm(24);
      line-height: vwm(34);
      margin-bottom: vwm(46);
      font-weight: 400;
    }
  }

  &-section-subtitle {
    font-size: vw(24);
    line-height: vw(28.001);
    margin-bottom: vw(7);
  }

  &-mission {
    padding-top: vw(100);
    padding-bottom: vw(170);
  }

  &-section-item {
    &:not(:last-child) {
      margin-bottom: vw(60);
    }
  }

  &-advantages {
    padding-top: vw(100);
    padding-bottom: vw(380);

    .design-section-title {
      margin-bottom: vw(90);
    }
  }

  &-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @include max-width(mobile) {
      padding-left: vwm(18);
      padding-right: vwm(18);
      flex-direction: column;
      justify-content: flex-start;
    }

    &--full {
      padding-left: 0;

      @include max-width(mobile) {
        padding-right: 0;
      }
    }

    &--text {
      justify-content: flex-start;
    }

    &__img__text {
      .design-text {
        max-width: vw(230);
      }
    }

    &[data-container="start"] {
      margin-bottom: vw(78);

      @include max-width(mobile) {
        margin-bottom: vw-m(47);
      }
    }

    &[data-container="1"] {
      padding: vw(132) vw(125);
      align-items: center;

      @include max-width(mobile) {
        padding: vwm(92) vwm(18);
      }

      .design-left {
        margin-right: vw(125);
        width: vw(785);

        @include max-width(mobile) {
          width: 100%;
          margin-right: 0;
        }

        img {
          width: 100%;

          @include max-width(mobile) {
            padding-right: 0;
            padding-bottom: 0;
            width: 100%;
          }
        }
      }

      .design-right {
        padding-right: vw(125);
        width: vw(531);
        box-sizing: content-box;

        @include max-width(mobile) {
          padding-top: vwm(46);
          padding-right: 0;
          width: 100%;
        }
      }

      .design-section-title {
        margin-bottom: vw(68);
      }
    }

    &[data-container="1a"] {
      display: block;
      padding-bottom: vw(132);
      width: vw(895);
      margin: 0 auto;

      @include max-width(mobile) {
        width: 100%;
        padding-bottom: 0;

        .design-section-title {
          margin-bottom: vwm(20);
        }
      }
    }

    &[data-container="20"] {
      padding-top: vw(132);
      padding-bottom: vw(132);

      .design-right {
        width: vw(895);
        margin: 0 auto;

        @include max-width(mobile) {
          width: 100%;
        }
      }

      @include max-width(mobile) {
        padding-top: vwm(92);
        padding-bottom: vwm(20);
      }
    }

    &[data-container="20a"] {
      padding-top: 0;
      padding-bottom: vw(202);

      .design-right {
        width: vw(895);
        margin: 0 auto;

        @include max-width(mobile) {
          width: 100%;
        }
      }

      @include max-width(mobile) {
        margin-top: vwm(-40);
        padding-bottom: vwm(132);
      }
    }

    &[data-container="2"] {
      padding-bottom: vw(140);

      @include max-width(mobile) {
        padding-bottom: vwm(92);
      }

      .design-slider {
        height: vw(620);
        padding-bottom: vw(74);
        box-sizing: content-box;

        img {
          height: 100%;
          object-fit: cover;
        }

        @include max-width(mobile) {
          height: vwm(324);
          padding-bottom: vwm(72);
        }
      }

      .design-slide {
        transition: opacity .5s ease;

        &:not(.swiper-slide-active) {
          opacity: .7;
        }
      }

      .slider-pagination {
        text-align: center;
        padding-top: vw(55);
        font-size: vw(16);
        line-height: vw(19);
        color: #999;

        @include max-width(mobile) {
          padding-top: vwm(40);
          height: vwm(32);
          font-size: vwm(14);
          line-height: vwm(32);
        }
      }

      ::v-deep .swiper-pagination-current {
        color: #2e2e2e;
      }

      @include max-width(mobile) {
        padding-top: vw-m(48);
      }
    }

    &[data-container="30"] {
      padding-bottom: vw(125);
    }

    &[data-container="3"] {
      padding-bottom: vw(132);
      background-color: #fff;
      align-items: stretch;

      @include max-width(mobile) {
        padding-top: vwm(46);
        padding-bottom: vwm(56);
      }

      .design-left {
        width: 50%;
        padding-top: vw(132);
        padding-left: vw(125);

        @include max-width(mobile) {
          width: 100%;
          padding-left: 0;
          padding-top: 0;
        }

        .sticky {
          position: sticky;
          top: calc(#{$header-height} + #{vw(132)});

          @include max-width(mobile) {
            position: static;
          }
        }

        .design-section-title {
          @include max-width(mobile) {
            margin-top: 0;
            margin-bottom: vwm(32);
          }
        }

        .design-text {
          width: vw(530);

          @include max-width(mobile) {
            width: 100%;
          }
        }
      }

      .design-right {
        width: vw(784);
        padding-top: vw(132);
        margin-right: vw(125);

        @include max-width(mobile) {
          width: 100%;
        }

        .product {
          &__item {
            @include max-width(mobile) {
              display: none;
            }

            &-title {
              font-size: vw(22);
              line-height: vw(32);
              color: #2e2e2e;
              margin-bottom: vw(28);
              position: relative;

              @include max-width(mobile) {
                font-size: vwm(15);
                line-height: vwm(18);
                margin-bottom: vwm(12);
                margin-top: vwm(25);
              }
            }

            &-counter {
              font-size: vw(16);
              color: #999;
              position: absolute;
              top: vw(5);
              right: vw(0);

              &--active {
                color: #2e2e2e;
              }

              @include max-width(mobile) {
                font-size: vwm(14);
                top: 0;
              }
            }

            &-desc {
              max-width: vw(740);
              color: #666;
              margin-bottom: vw(55);
              font-size: vw(18);
              line-height: vw(31);

              @include max-width(mobile) {
                max-width: 100%;
                font-size: vwm(12);
                line-height: vw-m(12);
                letter-spacing: 0.01em;
                color: #666666;
                font-family: "Helvetica";
                margin-bottom: 0;
              }
            }

            &:not(:last-child) {
              margin-bottom: vw(132);
            }
          }
        }
      }

      @include max-width(mobile) {
        .design-right {
          margin-top: vw-m(48);
          padding-right: 0;
          width: calc(100% + 2*#{vwm(18)});
          margin-left: vwm(-18);

          .swiper-container {
            padding-left: vwm(18);
          }
        }

        .swiper-slide {
          width: vwm(306);
          margin-right: vwm(18);

          img {
            width: 100%;
          }
        }
      }
    }

    &[data-container="7"] {
      align-items: center;
      padding-bottom: vw(65);
      padding-top: vw(132);

      @include max-width(mobile) {
        padding-top: vwm(92);
        padding-bottom: 0;
      }

      .design-slider__button {
        display: none;

        @include max-width(mobile) {
          display: flex;
        }
      }

      .design-right {
        width: 50%;
        padding-left: vw(125);

        @include max-width(mobile) {
          width: 100%;
          padding-left: 0;
        }

        .design-section-title {
          @include max-width(mobile) {
            margin-bottom: vwm(32);
          }
        }

        p {
          width: vw(547);
          font-size: vw(18);
          line-height: vw(26);
          color: #666;

          @include max-width(mobile) {
            width: 100%;
            font-size: vwm(15);
            line-height: vwm(26);
            color: #666;
            font-family: "Helvetica";
            margin-bottom: vwm(46);
          }
        }
      }

      .slider {
        width: 50%;

        @include max-width(mobile) {
          width: 100%;
          padding-left: 0;
        }

        &-inner {
          margin-right: auto;
          width: vw(784);
          height: vw(784);
          position: relative;

          @include max-width(mobile) {
            width: 100%;
            height: vwm(324);
            padding-bottom: vwm(72);
            box-sizing: content-box;
            padding-left: 0;
          }
        }

        .swiper-container {
          height: 100%;

          img {
            max-width: 100%;
          }
        }

        &-controls {
          text-align: center;
          padding-top: vw(55);
          font-size: vw(16);
          line-height: vw(19);
          color: #999;

          ::v-deep .swiper-pagination-current {
            color: #2e2e2e;
          }

          @include max-width(mobile) {
            font-size: vwm(14);
            line-height: vwm(32);
            padding-top: 0;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
          }
        }

        .swiper-button-next {
          @include min-width(mobile) {
            position: absolute;
            cursor: pointer;
            cursor: url("~@/assets/svg/arrowcircleright.svg"), auto;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0%;
            width: 100%;
            height: 100%;
            z-index: 2;
            background: none;
            margin: 0;
            outline: none !important;

            &.swiper-button-disabled {
              pointer-events: all;
            }
          }
        }
      }

      @include max-width(mobile) {
        .interior-section__card-text {
          margin-bottom: vw-m(24);
        }

        .slide__pagi {
          font-size: vw-m(44);
          line-height: 1;
          height: auto;
          font-weight: 200;
          margin-top: vw-m(20);
          display: inline-block;
          letter-spacing: 0.01em;
          color: #cdcdcd;
        }

        .swiper-slide {
          width: vw-m(528);
          margin-right: vw-m(20);
        }
      }

      .interior-section__desc {
        width: vw(550);
        padding-left: vw(76);
        box-sizing: content-box;
      }

      .interior-section__images {
        width: 50%;
      }
    }

    &[data-container="8"] {
      margin-bottom: vw(80);

      div:nth-child(1) {
        width: vw(745);
        background-image: url("~@/assets/img/design/des11.jpg");
      }

      div:nth-child(2) {
        width: vw(835);
        background-image: url("~@/assets/img/design/des10.jpg");
      }

      @include max-width(mobile) {
        margin-bottom: vw-m(85);

        img+img {
          margin-top: vw-m(32);
        }
      }
    }

    &[data-container="9"] {
      margin-bottom: vw(125);

      @include max-width(mobile) {
        margin-bottom: vw-m(90);
        padding-left: 0;
        padding-right: 0;
      }

      .design-content__img-row--three {
        height: vw(370);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

        &:nth-child(1) {
          width: vw(547);
          background-image: url("~@/assets/img/design/des12.jpg");
        }

        &:nth-child(2) {
          width: vw(654);
          background-image: url("~@/assets/img/design/des13.jpg");
        }

        &:nth-child(3) {
          width: vw(364);
          background-image: url("~@/assets/img/design/des14.jpg");
        }

        @include max-width(mobile) {
          display: none;
        }
      }
    }

    &[data-container="10"] {
      padding-bottom: vw(125);

      @include max-width(mobile) {
        padding-bottom: vw-m(90);
      }
    }

    &[data-container="11"] {
      @include max-width(mobile) {
        padding-bottom: vw-m(90);
      }
    }
  }

  &-left {
    @include max-width(mobile) {
      width: 100%;
    }
  }

  &-right {
    font-size: vw(18);
    line-height: vw(28.001);
    position: relative;

    @include max-width(mobile) {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
    }

    &__counter {
      position: absolute;
      top: 0;
      left: vw(48);

      @include max-width(mobile) {
        position: static;
        font-size: vw-m(18);
        line-height: vw-m(38);
        color: #848689;
        font-weight: 300;
      }
    }

    &__title {
      color: #37393b;
      font-size: vw(24);
      line-height: vw(28.001);
      margin-bottom: vw(20);

      @include max-width(mobile) {
        font-size: vw-m(18);
        line-height: vw-m(38);
        color: #848689;
        font-weight: 400;
      }
    }

    &__text {
      @include text;
      color: #37393b;
      font-size: vw(19);

      @include max-width(mobile) {
        font-size: vw-m(18);
        line-height: vw-m(38);
        color: #848689;
        font-weight: 300;
      }
    }
  }

  &-first {
    p+p {
      margin-top: vw(60);
    }
  }

  &-content {
    &__img {
      margin-bottom: vw(54);

      &--fullscreen {
        width: 100%;
      }

      &-full {
        width: 100%;
      }

      &-first {
        width: 100%;
      }

      &-col {
        display: block;
        padding-right: vw(163);
        width: 100%;

        &:not(:last-child) {
          margin-bottom: vw(70);
        }

        @include max-width(mobile) {
          padding-right: 0;
        }
      }

      &-row {
        max-height: vw(400);

        &:nth-child(2) {
          margin-left: vw(36);
          margin-right: vw(36);
        }

        &--twin {
          height: 42vw;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;

          @include max-width(mobile) {
            display: none;
          }
        }
      }
    }
  }

  &-slider {
    @include max-width(mobile) {
      display: block;
      width: 100%;
    }
  }

  &-slide {
    width: auto;
    height: auto;

    img {
      width: auto;
      height: vw-m(586);
    }

    @include max-width(mobile) {
      width: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &__img-mob {
    display: none;

    @include max-width(mobile) {
      display: block;
      width: 100%;
    }
  }

  @include max-width(mobile) {
    .full-section {
      overflow: hidden;
    }

    .full-section {
      &__container {
        height: 95vh;
      }

      &__title {
        margin-bottom: 0 !important;
      }

      &__foreground {
        padding-left: vw-m(27);
      }
    }
  }
}

.show-mob {
  display: none;

  @include max-width(mobile) {
    display: block;
  }
}

.hide-mob {
  @include max-width(mobile) {
    display: none;
  }
}

.design {

  .swiper-button-prev,
  .swiper-button-next {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:after {
      display: none;
    }
  }

  .swiper-button-next {
    top: calc(50% - #{vw(74)}/2 - #{vw(46) / 2});
    margin-top: 0;
    right: vw(32);

    @include max-width(mobile) {
      top: auto;
      bottom: 0;
      right: 0;
    }
  }

  .swiper-button-prev {
    top: calc(50% - #{vw(74)}/2 - #{vw(46) / 2});
    margin-top: 0;
    left: vw(32);

    @include max-width(mobile) {
      top: auto;
      bottom: 0;
      left: 0;
    }
  }

  &-slider {
    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: vw(46);
      height: vw(46);
      background: rgba(255, 255, 255, 0.6);
      mix-blend-mode: normal;
      border: 1px solid #BDBDBD;
      border-radius: 50%;

      @include max-width(mobile) {
        width: vwm(32);
        height: vwm(32);
      }
    }
  }

  @import '@/styles/rellax-screen.scss';
}
</style>
